import React from 'react';

import Button from 'components/Button';
import Money from 'components/Money';
import Table from 'components/Table';
import Paginator from 'components/Paginator';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

import {formatDate} from 'utils/datetime';

import './styles.css';

class OneOffChargeReasonsTable extends React.Component<any> {
  render() {
    const {
      reasons,
      pagination,
      onPageChange,
      openEditOneOffChargeReasonModal,
      deleteOneOffChargeReason
    } = this.props;

    return (
      <div className="OneOffChargeReasonsTable">
        <Table>
          <Table.Header>
            <Table.HeaderItem heading="Label" />
            <Table.HeaderItem heading="Description" />
            <Table.HeaderItem heading="Amount" />
            <Table.HeaderItem heading="Account" />
            <Table.HeaderItem heading="Created" />
            <Table.HeaderItem />
          </Table.Header>
        </Table>
        <div className="OneOffChargeReasonsTable__body">
          <Table>
            <Table.Body>
              {reasons.map(reason => (
                <Table.Row
                  key={reason.id}
                  onClick={() => openEditOneOffChargeReasonModal({reason})}>
                  <Table.Cell>{reason.label}</Table.Cell>
                  <Table.Cell className="OneOffChargeReasonsTable__cell__description">
                    <div>{reason.description}</div>
                  </Table.Cell>
                  <Table.Cell>
                    <Money amount={reason.amount} balance={false} />
                  </Table.Cell>
                  <Table.Cell>
                    {reason.xeroAccount.code} - {reason.xeroAccount.name}
                  </Table.Cell>
                  <Table.Cell>{formatDate(reason.createdAt)}</Table.Cell>
                  <Table.Cell>
                    <ClickIconWithNoPropagation
                      onClick={() =>
                        deleteOneOffChargeReason({reasonId: reason.id})
                      }>
                      <Button clear />
                    </ClickIconWithNoPropagation>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        <Paginator pagination={pagination} onPageChange={onPageChange} />
      </div>
    );
  }
}

export default OneOffChargeReasonsTable;
